import {
  Avatar, Box, Button, Divider, Drawer, IconButton, InputAdornment,
  List, ListItem, Paper, TextField, Typography, Collapse,
  Dialog,
  DialogTitle,
  Grid,
  Badge
} from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import wefrothLogo from '../../Assets/Image/logo-wefroth.png'
import LikeIcon from '../../Assets/Image/LikeIcon.png'
import CartIcon from '../../Assets/Image/Cart.png'
import SearchIcon from "../../Assets/Image/Search.png"
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../Redux/store'
import { AccountCircleOutlined, ArrowDropDown, CancelOutlined, Close, CloudUploadOutlined, ExpandLess, ExpandMore, Menu } from '@mui/icons-material'
import { setCartList, setToken, setuserDetails, setVenderDetails, setWishList } from '../../Redux/Reducers/globalSlice'
import { ApiCreateShopProfile, ApiGetAllCategory, ApiGetCartlist, ApiGetShopProfile, ApiGetWishlist, ApiUploadImage } from '../../Core/Apicall'
import { toast } from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom'
import { Category } from '../../Models/Category'
import { PiCubeLight } from "react-icons/pi";


function Header() {
  const [hoveredMenu, setHoveredMenu] = useState<string | null>(null)
  const [activeMenu, setActiveMenu] = useState<Category[]>([])
  const [openLoginMenu, setOpenLoginMenu] = useState<boolean>(false)
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [expandedDrawerItem, setExpandedDrawerItem] = useState<string | null>(null)
  const [expandedSection, setExpandedSection] = useState<number | null>(null)

  const { userDetails, teamId, venderDetails, wishlist, cartlist } = useSelector((state: RootState) => state.global)
  const loginBtnRef = useRef<HTMLButtonElement | null>(null)
  const dispatch = useDispatch()
  const [menuPosition, setMenuPosition] = useState({ left: 0, top: 0, width: 0 })
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const navigate = useNavigate()
  const [menCategories, setMenCategories] = useState<Category[]>([])
  const [womenCategories, setWomenCategories] = useState<Category[]>([])
  const [kidsCategories, setKidsCategories] = useState<Category[]>([])
  const [searchterm, setSearchTerm] = useState<string>("")
  const [debouncesearch, setDebounceSearch] = useState<string>("")

console.log("Cart List", cartlist)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounceSearch(searchterm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchterm]);


  useEffect(() => {
    if (debouncesearch?.trim()) {
      navigate(`/products/search-product/${debouncesearch}`)
    }
  }, [debouncesearch])

  const [formData, setFormData] = useState({
    display_name: "",
    banner_url: "",
    logo_url: "",
    theme_color: "#008000",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      const data = {
        ...formData,
        profileId: teamId,
        seller_type: "TEAM"
      }
      const res = await ApiCreateShopProfile(data)
      if (res.status || res.success) {
        setOpenDialog(false)
        window.open('/vender/Dashboard')
      }
    } catch (error) {

    }
  };



  useEffect(() => {
    if (hoveredMenu)
      setActiveMenu(getactivecategory(hoveredMenu))
  }, [hoveredMenu])

  useEffect(() => {
    const button = loginBtnRef.current
    button?.classList.add("login-btn")
    button?.classList.remove("d-none")
    const timer = setTimeout(() => {
      button?.classList.remove("login-btn")
      button?.classList.add("d-none")
    }, 10000)
    return () => clearTimeout(timer)
  }, [])

  const handleOpenLoginPopup = (event: React.MouseEvent<HTMLDivElement>, status: boolean) => {
    const button = loginBtnRef.current
    if (status && !userDetails) {
      button?.classList.add("login-btn")
      button?.classList.remove("d-none")
    } else if (status && userDetails && event) {
      setOpenLoginMenu(true)
      const rect = event.currentTarget.getBoundingClientRect()
      setMenuPosition({ left: rect.left + window.scrollX, top: rect.bottom + window.scrollY, width: rect.width })
    } else if (!status && userDetails) {
      setOpenLoginMenu(false)
    } else if (!status) {
      button?.classList.remove("login-btn")
      button?.classList.add("d-none")
    }
  }

  const handleLogout = () => {
    dispatch(setuserDetails(null))
    dispatch(setCartList(null))
    dispatch(setWishList(null))
    dispatch(setToken(''))
    setOpenLoginMenu(false)
  }


  const getactivecategory = (type: string) => {
    switch (type) {
      case "MEN":
        return menCategories
        break;
      case "WOMEN":
        return womenCategories
        break;

      case "KIDS":
        return kidsCategories
        break;

      default:
        return menCategories

    }
  }

  // ─── Mobile Drawer ───────────────────────────────────────────────
  const MobileDrawer = (
    <Drawer
      anchor="left"
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      slotProps={{
        paper: {
          sx: { width: 300, bgcolor: 'var(--primary-bg-color)', color: 'white' }
        }
      }}
    >
      {/* Drawer Header */}
      <Box className='d-flex align-items-center justify-content-between p-3'>
        <Box component='img' src={wefrothLogo} height={30} />
        <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: 'white' }}>
          <Close />
        </IconButton>
      </Box>

      <Divider sx={{ borderColor: '#ffffff1a' }} />

      <Divider sx={{ borderColor: '#ffffff1a' }} />

      {/* Nav Items */}
      <List disablePadding>
        {["MEN", "WOMEN", "KIDS"].map((item) => (
          <Box key={item}>
            <ListItem
              className='pointer'
              onClick={() => setExpandedDrawerItem(expandedDrawerItem === item ? null : item)}
              sx={{ justifyContent: 'space-between', py: 1.5, px: 3 }}
            >
              <Typography className='fs-14 fw-bold text-white'>{item}</Typography>
              {expandedDrawerItem === item ? <ExpandLess sx={{ color: 'white' }} /> : <ExpandMore sx={{ color: 'white' }} />}
            </ListItem>

            <Collapse in={expandedDrawerItem === item} timeout="auto" unmountOnExit>
              {getactivecategory(item)
                ?.filter((category: Category) => category.level === 1)
                ?.map((category: Category) => (
                  <Box key={category.categoryId}>
                    <ListItem
                      className="pointer"
                      onClick={() =>
                        setExpandedSection(
                          expandedSection === category.categoryId
                            ? null
                            : category.categoryId
                        )
                      }
                      sx={{ py: 1, px: 4, justifyContent: "space-between" }}
                    >
                      <Link className='text-decoration-none' to={`/products/product-category/${category.slug}`}><Typography className="fs-14 fw-semibold text-blue">
                        {category.categoryName}
                      </Typography></Link>

                      {expandedSection === category.categoryId ? (
                        <ExpandLess sx={{ color: "#aaa" }} fontSize="small" />
                      ) : (
                        <ExpandMore sx={{ color: "#aaa" }} fontSize="small" />
                      )}
                    </ListItem>

                    <Collapse
                      in={expandedSection === category.categoryId}
                      timeout="auto"
                      unmountOnExit
                    >
                      {category.children?.map((subItem: Category) => (
                        <ListItem
                          key={subItem.categoryId}
                          sx={{ py: 0.5, px: 6 }}
                        >
                          <Link className='text-decoration-none' to={`/products/product-category/${subItem.slug}`}> <Typography className="fs-14 text-white">
                            {subItem.categoryName}
                          </Typography>
                          </Link>
                        </ListItem>
                      ))}
                    </Collapse>
                  </Box>
                ))}
            </Collapse>

            <Divider sx={{ borderColor: '#ffffff1a' }} />
          </Box>
        ))}
      </List>

      {/* User section in drawer */}
      <Box className='p-3 mt-auto'>
        <Box className='d-flex align-items-center gap-2 mb-3'>
          <Avatar src={userDetails?.profile_picture}>{userDetails?.first_name?.[0]}</Avatar>
          <Typography className='fs-14 text-white'>{userDetails ? `${userDetails?.first_name} ${userDetails?.lastName}` : 'Guest'}</Typography>
        </Box>
        {userDetails
          ? <Button variant='outlined' fullWidth className='btn-outlined' onClick={handleLogout}>Log out</Button>
          : <Button variant='contained' fullWidth className='btn-main'>Login</Button>
        }
      </Box>
    </Drawer>
  )

  const uploadFile = async (file: File, type: "banner_url" | "logo_url") => {
    try {
      // setLoading(true);

      const payload = new FormData();
      payload.append("images[]", file);
      payload.append("type", 'category');

      const res = await ApiUploadImage(payload)
      if (res.status || res.success) {
        setFormData((prev) => ({
          ...prev,
          [type]: res.data[0].media_url,
        }));
      }
      else {
        toast.error(res.message.replace(/<[^>]*>/g, ""))
      }

    } catch (error: any) {
      console.error(error);
      toast.error(error?.message || "Something went wrong");
    } finally {
      // setLoading(false);
    }
  };


  const getShopProfile = async () => {
    try {
      const data = `?profileId=${teamId}`
      const res = await ApiGetShopProfile(data)
      if (res.success || res.status) {
        dispatch(setVenderDetails(res?.data?.data[0]))
      }
    } catch (error: any) {
      console.log("Error", error)
      toast.error(error?.message || "Something went wrong");
    }
  }


  const GetWishlist = async () => {
    try {
      const res = await ApiGetWishlist()
      if (res?.success) {
        dispatch(setWishList(res?.data))
      }
    } catch (error: any) {
      console.log("Error", error)
      toast.error(error?.message || "Something went wrong");
    }
  }
  const GetCartlist = async () => {
    try {
      const res = await ApiGetCartlist()
      if (res?.success) {
        dispatch(setCartList(res?.data))
      }
    } catch (error: any) {
      console.log("Error", error)
      toast.error(error?.message || "Something went wrong");
    }
  }


  useEffect(() => {
    teamId && userDetails && getShopProfile()
    userDetails && GetWishlist()
    userDetails && GetCartlist()
  }, [teamId, userDetails])

  const getCategories = async (type: string) => {
    try {
      const data = `?type=${type}`
      const res = await ApiGetAllCategory(data)
      if (res?.success) {
        switch (type) {
          case "MEN":
            setMenCategories(res?.data)
            break;
          case "WOMEN":
            setWomenCategories(res?.data)
            break;

          case "KIDS":
            setKidsCategories(res?.data)
            break;

        }
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong");
    }
  }

  useEffect(() => {
    ["MEN", "WOMEN", "KIDS"]?.map((item) => { getCategories(item) })
  }, [])

  return (
    <>
      <Box className='header position-relative'>
        <Box className='d-flex align-items-center justify-content-between h-100 px-3' sx={{ width: { xs: "100%", lg: "100%" } }}>

          {/* ── Left: Hamburger (mobile) + Logo + Nav (desktop) ── */}
          <Box className='d-flex align-items-center gap-3 h-100 py-2'>

            {/* Hamburger — visible only on mobile/tablet */}
            <IconButton
              onClick={() => setDrawerOpen(true)}
              sx={{ color: 'white', display: { xs: 'flex', md: 'none' } }}
            >
              <Menu />
            </IconButton>

            <Link to={'/'} className='h-lg-100 h-75'><Box component='img' src={wefrothLogo} className='h-100' /></Link>

            <List
              onMouseLeave={() => setHoveredMenu(null)}
              className='d-none d-lg-flex text-white'
              sx={{ display: { xs: 'none', md: 'flex' } }}
            >
              {["MEN", "WOMEN", "KIDS"].map((item) => (
                <ListItem
                  key={item}
                  onMouseEnter={(event) => {
                    setHoveredMenu(item)
                    const rect = event.currentTarget.getBoundingClientRect()
                    setMenuPosition({ left: rect.left + window.scrollX, top: rect.bottom + window.scrollY, width: rect.width })
                  }}
                  className='fs-14 fw-bold pointer'
                >
                  {item}
                </ListItem>
              ))}
            </List>
          </Box>

          <Box
            onMouseLeave={(e: React.MouseEvent<HTMLDivElement>) => handleOpenLoginPopup(e, false)}
            className='d-flex align-items-center justify-content-between search-input gap-3 h-100'
          >
            <TextField
              className='hdr-search h-100'
              placeholder='Search Products or Brands'
              variant='outlined'
              sx={{ display: { xs: 'none', md: 'block' } }}
              value={searchterm}
              onChange={(e) => { setSearchTerm(e.target.value) }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Box component='img' src={SearchIcon} height={24} width={24} />
                    </InputAdornment>
                  ),
                },
              }}
            />

            {/* Search icon only on mobile */}
            {/* <IconButton sx={{ color: 'white', display: { xs: 'flex', md: 'none' } }}>
            <Box component='img' src={SearchIcon} height={24} width={24} />
          </IconButton> */}

            <Box className='d-flex align-items-center' sx={{ gap: { xs: 1, lg: 3 } }}>
              {/* Profile — hidden on mobile (inside drawer instead) */}
              <Box
                className="d-flex gap-2 align-items-center position-relative pointer"
                onMouseEnter={(e: React.MouseEvent<HTMLDivElement>) => handleOpenLoginPopup(e, true)}
                sx={{ display: { xs: 'none', md: 'flex' } }}
              >
                <Avatar className='avtar' src={userDetails?.profile_picture}>{userDetails?.first_name?.[0]}</Avatar>
                <Typography className='fs-14 d-none d-md-inline-block text-white whitespace' sx={{ width: 'fit-content' }}>
                  {userDetails ? `${userDetails?.first_name} ${userDetails?.last_name}` : 'Login'} <ArrowDropDown />
                </Typography>
                {!userDetails && (
                  <Button onClick={() => { navigate('/login') }} ref={loginBtnRef} className='btn-main mt-2 d-none top-100 w-100 position-absolute'>Login</Button>
                )}
              </Box>

              {/* <Box component='img' src={LikeIcon} height={28} width={28} className='pointer' /> */}
              <IconButton className="m-0 p-0 position-relative">
                <Badge badgeContent={wishlist?.length} color='success'>
                    <Box
                      component="img"
                      src={LikeIcon}
                      height={28}
                      width={28}
                      className="pointer"
                    />
                </Badge>
              </IconButton>
              <Link to={'/cart'} className="m-0 p-0 position-relative">
                <Badge badgeContent={cartlist?.items?.length} color='success'>
                    <Box
                      component="img"
                      src={CartIcon}
                      height={28}
                      width={28}
                      className="pointer"
                    />
                </Badge>
              </Link>
              {teamId && !venderDetails && userDetails && (
                <Button onClick={() => { setOpenDialog(true) }} className='btn-main px-3 py-1'>Create Shop</Button>
              )}
              {venderDetails && userDetails && (
                <Button onClick={() => { navigate('/vender/Dashboard') }} className='btn-main px-3 py-1'>Manage Shop</Button>
              )}
              {/* <Box component='img' src={CartIcon} height={28} width={28} className='pointer' /> */}
            </Box>
          </Box>
        </Box>

        {/* ── Desktop Dropdown ── */}
        {hoveredMenu && (
          <Paper
            onMouseLeave={() => setHoveredMenu(null)}
            elevation={3}
            onMouseEnter={() => setHoveredMenu(hoveredMenu)}
            className='category-list'
            sx={{ top: menuPosition.top, left: menuPosition.left }}
          >
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: `repeat(${activeMenu?.filter((category: Category) => category.level === 1)?.length}, 1fr)` },
                gap: 3,
              }}
            >
              {activeMenu?.filter((category: Category) => category.level === 1).map((section: Category, index: number) => (
                <Box
                  key={section.categoryId}
                  sx={{ px: 2, borderRight: index !== activeMenu?.filter((category: Category) => category.level === 1).length - 1 ? '1px solid #FFFFFF1A' : 'none' }}
                >
                  <Link className='text-decoration-none' to={`/products/product-category/${section.slug}`}> <Typography className='fs-14 fw-bold text-blue mb-2'>{section.categoryName}</Typography></Link>
                  {section.children?.map((subItem: Category) => (
                    <Link className='text-decoration-none' to={`/products/product-category/${subItem.slug}`}> <Typography
                      key={subItem?.categoryId}
                      className='text-white fs-14 pointer mb-1'
                      sx={{ '&:hover': { fontWeight: 600, color: '#000' } }}
                    >
                      {subItem?.categoryName}
                    </Typography>
                    </Link>
                  ))}
                </Box>
              ))}
            </Box>
          </Paper>
        )}

        {/* ── Login Menu Popup ── */}
        {openLoginMenu && (
          <Paper
            onMouseLeave={() => setOpenLoginMenu(false)}
            elevation={3}
            onMouseEnter={() => setOpenLoginMenu(true)}
            className='category-list pb-3'
            sx={{
              top: menuPosition.top,
              // left: 'auto',
              right: { xs: 10, md: "none" },
              left: { xs: 'auto', md: menuPosition.left },
              maxWidth: { xs: 'calc(100vw - 16px)', sm: 'auto' },
              width: { xs: 200, sm: 'fit-content' },
            }}
          >
            <List className='p-0 pe-5'>
              <ListItem className='d-flex px-0 pointer align-items-center gap-2'>
                <AccountCircleOutlined className='text-white' />
                <Typography className='fs-14 text-white'>My Profile</Typography>
              </ListItem>
              <ListItem className='d-flex px-0 pointer align-items-center gap-2'>
                <Link className='d-flex px-0 pointer align-items-center gap-2 text-decoration-none' to='/my-orders'>
                {/* <Order className='text-white' /> */}
                {PiCubeLight({size: 24, color: 'var(--white-color)'})}
                <Typography className='fs-14 text-white'>My Orders</Typography>
                </Link>
              </ListItem>
            </List>
            <Button variant='outlined' fullWidth className='btn-outlined mt-3' onClick={handleLogout}>Log out</Button>
          </Paper>
        )}

        {MobileDrawer}
      </Box>
      <Box className='p-3 d-block d-md-none search-input2 bg-main'>
        <TextField
          fullWidth
          placeholder='Search Products or Brands'
          variant='outlined'
          value={searchterm}
          onChange={(e) => { setSearchTerm(e.target.value) }}
          size='small'
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Box component='img' src={SearchIcon} height={20} width={20} />
                </InputAdornment>
              ),
            },
          }}
          sx={{ '& .MuiOutlinedInput-root': { color: 'white', borderColor: 'white' } }}
        />
      </Box>

      <Dialog
        slotProps={{
          paper: {
            sx: {
              bgcolor: "var(--primary-color)",
              color: "#fff",
              boxShadow: "0px 0px 5px #FFFFFF",
              height: 'fit-content',
              width: '100%',
              borderRadius: '10px'
            },
          },
        }}
        open={openDialog}>
        <Box className='p-3 h-100 d-flex flex-column gap-4'>
          <Box className='d-flex align-items-center justify-content-between'>
            <Typography className='fs-24 text-white'>Create Shop Profile</Typography>
            <IconButton onClick={() => { setOpenDialog(false) }} className='p-0 m-0'>
              <CancelOutlined className='text-white fs-28' />
            </IconButton>
          </Box>
          <Box
            sx={{ flex: 1 }}
            component="form"
            className='form d-flex flex-column gap-4  w-100'
          >
            <Box sx={{ flex: 1 }}>
              <TextField
                label="Display Name"
                name="display_name"
                value={formData.display_name}
                onChange={handleChange}
                fullWidth
                required
              />
              <Box className="d-flex align-items-center gap-2 my-4">
                <TextField
                  label="Theme Color"
                  name="theme_color"
                  value={formData.theme_color}
                  onChange={handleChange}
                  fullWidth
                  required
                />

                <input
                  type="color"
                  value={formData.theme_color}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      theme_color: e.target.value,
                    })
                  }
                  style={{
                    width: 60,
                    height: 56,
                    cursor: "pointer",
                  }}
                />
              </Box>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <Box>
                    <Typography className="text-white mb-2">
                      Banner Image *
                    </Typography>

                    <Box
                      component="label"
                      sx={{
                        width: "100%",
                        height: 180,
                        border: "2px dashed rgba(255,255,255,0.3)",
                        borderRadius: "12px",
                        cursor: "pointer",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        transition: "all .3s ease",

                        "&:hover": {
                          borderColor: "#fff",
                          backgroundColor: "rgba(255,255,255,0.05)",
                        },
                      }}
                    >
                      <input
                        hidden
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) uploadFile(file, "banner_url");
                        }}
                      />

                      {formData.banner_url ? (
                        <>
                          <Box
                            component="img"
                            src={formData.banner_url}
                            alt="Banner"
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />

                          <Box
                            sx={{
                              position: "absolute",
                              inset: 0,
                              bgcolor: "rgba(0,0,0,0.5)",
                              opacity: 0,
                              transition: ".3s",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",

                              "&:hover": {
                                opacity: 1,
                              },
                            }}
                          >
                            <Typography className='text-white fw-bold'>
                              Change Banner
                            </Typography>
                          </Box>
                        </>
                      ) : (
                        <Box
                          className='text-center text-white'
                        >
                          <CloudUploadOutlined
                            sx={{
                              fontSize: 50,
                              mb: 1,
                            }}
                          />

                          <Typography className='fw-bold text-white'>
                            Upload Banner Image
                          </Typography>

                          <Typography
                            className='text-grey fs-12 mt-1'>
                            Click or drag & drop image here <br /> (PNG, JPG, SVG)
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Grid>
                <Grid size={5}>
                  <Box>
                    <Typography className="text-white mb-2">
                      Logo Image *
                    </Typography>

                    <Box
                      className='border-10 position-relative  pointer overflow-hidden d-flex align-items-center justify-content-center'
                      component="label"
                      sx={{
                        height: 180,
                        border: "2px dashed rgba(255,255,255,0.3)",
                        transition: "all .3s ease",

                        "&:hover": {
                          borderColor: "#fff",
                          backgroundColor: "rgba(255,255,255,0.05)",
                        },
                      }}
                    >
                      <input
                        hidden
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) uploadFile(file, "logo_url");
                        }}
                      />

                      {formData.logo_url ? (
                        <>
                          <Box
                            className='bg-white'
                            component="img"
                            src={formData.logo_url}
                            alt="Logo"
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              p: 1,
                            }}
                          />

                          <Box
                            sx={{
                              position: "absolute",
                              inset: 0,
                              bgcolor: "rgba(0,0,0,0.6)",
                              opacity: 0,
                              transition: ".3s",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",

                              "&:hover": {
                                opacity: 1,
                              },
                            }}
                          >
                            <Typography className='text-white fw-bold'>
                              Change Logo
                            </Typography>
                          </Box>
                        </>
                      ) : (
                        <Box
                          className='text-center text-white'
                        >
                          <CloudUploadOutlined
                            sx={{
                              fontSize: 40,
                              mb: 1,
                            }}
                          />

                          <Typography className='fs-14 fw-bold'>
                            Upload Logo
                          </Typography>

                          <Typography
                            className='text-grey fs-12 mt-1'>
                            Click or drag & drop image here <br /> (PNG, JPG, SVG)
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Grid>
              </Grid>

            </Box>

            <Button
              className='text-yellow bg-light-yellow border-5 py-2 transform'
              variant="contained"
              onClick={handleSubmit}
            >
              Create Profile
            </Button>
          </Box>
        </Box>
      </Dialog>

    </>
  )
}

export default Header